export default __webpack_public_path__ + "locales/ja-JP/About.json?hash=2dd46aed4c29c544fcd683480e739ef3";